import { startStreamingResponse } from '../api-fetch';
import { streamResponsePreview } from './utils/map-response-for-single-key-to-markdown';
import { getSupportedMarkdowns } from './utils/get-supported-markdown-from-schema';
import { runContextListAgainstFFs } from './utils/strip-context-list';
import { convoAIStatelessApiURL } from '../../prebuilt/utils';

/**
 * Summarises some text.
 *
 * Intended for use in EditorPluginAI config items.
 * @see {@link [EditorPluginAI](../../editor-plugin-ai.tsx)}
 *
 * @example
 * ```ts
 * triggerPromptRequest({ initialContext }) {
 *   return summary({
 *     text: initialContext.doc,
 *   });
 * }
 * ```
 *
 * @see https://hello.atlassian.net/wiki/spaces/CA3/pages/2485466879/Generative+AI+API+Specs#Summary-API-Signature---Non-Streaming
 */
// Note -- the current plan is to collapse api interactions into a single
// mechanism as part of our move to "api v2"
// https://hello.atlassian.net/wiki/spaces/CA3/pages/2631558196/Spec+Platformized+API+spec+for+generative+AI+endpoint (updated api v2)

export const summary = (input, customEndpoint) => {
  return function promptRequest(requestOptions) {
    const streamingResponseGenerator = startStreamingResponse({
      endpoint: customEndpoint || requestOptions.generativeAIApiUrl,
      payload: JSON.stringify({
        intentSchemaId: input.intentSchemaId,
        contextList: runContextListAgainstFFs(input.contextList),
        modelPlatform: 'OPENAI',
        outputLocale: input.userLocale,
        streaming: true,
        outputFormat: {
          outputFormatType: 'MARKDOWN',
          markdowns: getSupportedMarkdowns(input.editorSchema)
        },
        product: requestOptions.product,
        ...(input.backendModel === 'einstein' && {
          backendExperiment: 'EINSTEIN'
        })
      }),
      ...requestOptions
    });
    return streamResponsePreview({
      streamingResponseGenerator,
      streamingListener: input.streamingListener
    });
  };
};
export const summaryConvoAI = (input, customEndpoint) => {
  return function promptRequest(requestOptions) {
    const streamingResponseGenerator = startStreamingResponse({
      endpoint: customEndpoint || convoAIStatelessApiURL,
      payload: JSON.stringify({
        recipient_agent_named_id: 'editor_intent_agent',
        agent_input_context: {
          writing_intent: input.intentSchemaId,
          draft_full_content: input.fullDocument,
          draft_selected_content: input.currentSelection,
          supported_markdown_nodes: getSupportedMarkdowns(input.editorSchema),
          input_mime_type: 'text/markdown',
          output_mime_type: 'text/markdown',
          locale: input.userLocale,
          product: requestOptions.product
        }
      }),
      ...requestOptions
    });
    return streamResponsePreview({
      streamingResponseGenerator,
      isConvoAI: true
    });
  };
};